import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
import Manage from './views/Manage';
import Marketplace from './views/Marketplace';
import MarketplaceItem from './views/MarketplaceItem';
import Credits from './views/Credits';
import PageNotFound from './views/PageNotFound';
import Polls from './views/Polls';
import PollDetails from './views/PollDetails';
import PollLogs from './views/PollLogs';

Vue.use(Router);

const router = new Router({
	routes: [
		{
			path: '/marketplace',
			alias: '/',
			name: 'marketplace',
			component: Marketplace,
			meta: {
				requiresAuth: true
			}
		},
		{
			path: '/marketplace/:itemId',
			name: 'marketplaceItem',
			component: MarketplaceItem,
			meta: {
				requiresAuth: true
			}
		},
		{
			path: '/manage',
			name: 'manage',
			component: Manage,
			meta: {
				requiresAuth: true
			}
		},
		{
			path: '/credits',
			name: 'credits',
			component: Credits,
			meta: {
				requiresAuth: true
			}
		},
		{
			path: '/poll/:pollId',
			name: 'pollDetails',
			component: PollDetails,
			meta: {
				requiresAuth: true
			}
		},
		{
			path: '/poll/:pollId/logs',
			name: 'pollLogs',
			component: PollLogs,
			meta: {
				requiresAuth: true
			}
		},
		{
			path: '/polls',
			name: 'polls',
			component: Polls,
			meta: {
				requiresAuth: true
			}
		},
		{
			path: '/signout',
			alias: '/logout',
			beforeEnter: (to, from, next) => {
				store.dispatch('AUTH_LOGOUT', store.getters.refreshTokenJTI)
					.then(() => {
						// prepare redirect for auth service
						const reason = '?reason=' + (to.query.reason || 'logout');
						const destination = to.query.destination;
						const returnClient =  '&client=' + window.location.origin + '/' + (destination ? '%23' + destination : '');

						window.location.href = store.getters.AUTH_URL + reason + returnClient;
					});
			}
		},
		{
			path: "*",
			name: 'unknown',
			component: PageNotFound,
			meta: {
				requiresAuth: true
			}
		}
	]
});

router.beforeEach((to, from, next) => {
	// does not apply when auth is not required
	if (!to.meta.requiresAuth) {
		next();
		return;
	}

	if (to.query.referrerClient && from.path === '/') {
		store.commit('STORE_REFERRER_CLIENT', to.query.referrerClient + '?destination=' + (to.query.referrerPath || '/') + (to.query.bucket && ('&bucket=' + to.query.bucket) || ''));
	}

	const query = to.query;
	const params = to.params;
	const token = query.token;

	if (store && store.getters.isAuthenticated && !token) {
		next();
		return;
	}

	if (token) {
		store.dispatch('AUTH_REQUEST', {
				refreshToken: token
			})
			.then(() => {
				next();
			})
			.catch((reason)=>{
				//invalid token
				next({path: '/logout', query: { destination: to.path }});
			});
	} else {

		if (query.emailToken) {
			next({path: '/logout', query: { reason: 'email', destination: to.path }});
			return;
		}

		next({path: '/logout', query: { destination: to.path }});
	}
});

router.afterEach((to, from) => {
	let query = to.query;
	// clear token from url
	if (query.token) {
		delete query.token;
	}
});


export default router;



// WEBPACK FOOTER //
// ./src/routes.js